import { createLucideIcon } from "lucide-react";

export const Sorting91 = createLucideIcon(
    "Sorting91",
    [
        [
            "path",
            {
                d: "M16.5 19.999C15.7998 19.999 14.4915 18.0047 14 17.499",
                key: "1huvyy",
            },
        ],
        [
            "path",
            {
                d: "M16.5 19.999C17.2002 19.999 18.5085 18.0047 19 17.499",
                key: "10190x",
            },
        ],
        [
            "path",
            {
                d: "M16.5 19.999V3.999",
                key: "pdofqe",
            },
        ],
        [
            "path",
            {
                d: "M7 20.9994H5.5",
                key: "rvlnlz",
            },
        ],
        [
            "path",
            {
                d: "M7 20.9994H8.5",
                key: "1kf3xi",
            },
        ],
        [
            "path",
            {
                d: "M7 20.9994V14.9481C7 14.3736 7 14.0863 6.7696 14.0149C6.2631 13.8577 5.5 14.999 5.5 14.999",
                key: "f635ru",
            },
        ],
        [
            "path",
            {
                d: "M9 6.5V4.75C9 3.925 9 3.5126 8.7071 3.2563C8.4142 3 7.9428 3 7 3C6.0572 3 5.5858 3 5.2929 3.2563C5 3.5126 5 3.925 5 4.75C5 5.575 5 5.9874 5.2929 6.2437C5.5858 6.5 6.0572 6.5 7 6.5H9Z",
                key: "1okror",
            },
        ],
        [
            "path",
            {
                d: "M9 6.5V7.375C9 8.6124 9 9.2312 8.5607 9.6156C8.1213 10 7.4142 10 6 10H5",
                key: "155xyl",
            },
        ],
    ],
);
